import React, { useState, useEffect, useRef } from 'react';

export default function Navbar({ activeTab, setActiveTab, user, onLogout, onShowAuth }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Close on outside click/tap
  useEffect(() => {
    if (!menuOpen) return;
    function handleOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [menuOpen]);

  // Close menu and run action
  function go(action) {
    setMenuOpen(false);
    action();
  }

  const authTabs = [
    { id: 'watchlist', label: 'My Watchlist', icon: '🔔' },
    { id: 'account',   label: 'Account',      icon: '👤' },
  ];

  return (
    <nav className="navbar" ref={navRef}>
      {/* Dark overlay behind mobile menu */}
      {menuOpen && (
        <div className="nav-mobile-overlay" onClick={() => setMenuOpen(false)} />
      )}

      <div className="navbar-inner">

        {/* Brand */}
        <button
          className="navbar-brand"
          onClick={() => go(() => setActiveTab('coming_soon'))}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <div className="brand-icon">🎬</div>
          <span className="brand-name">Cinema<span> Alert</span></span>
        </button>

        {/* Desktop nav links (hidden on mobile via CSS) */}
        {user && (
          <div className="navbar-links">
            {authTabs.map(t => (
              <button
                key={t.id}
                className={`navbar-link${activeTab === t.id ? ' active' : ''}`}
                onClick={() => setActiveTab(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>
        )}

        {/* Desktop auth buttons (hidden on mobile via CSS) */}
        <div className="navbar-auth">
          {user ? (
            <>
              <span className="navbar-user">
                Hey, <strong>{user.name.split(' ')[0]}</strong>
              </span>
              <button className="btn btn-ghost btn-sm navbar-signout" onClick={onLogout}>
                Sign Out
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-ghost btn-sm" onClick={() => onShowAuth('login')}>
                Sign In
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => onShowAuth('signup')}>
                Sign Up Free
              </button>
            </>
          )}
        </div>

        {/* Hamburger — mobile only */}
        <button
          className={`nav-hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="nav-mobile-menu">
          {user ? (
            <>
              <div className="nav-mobile-greeting">
                Hey, <strong>{user.name.split(' ')[0]}</strong>
              </div>
              {authTabs.map(t => (
                <button
                  key={t.id}
                  className={`nav-mobile-item${activeTab === t.id ? ' active' : ''}`}
                  onClick={() => go(() => setActiveTab(t.id))}
                >
                  <span>{t.icon}</span> {t.label}
                </button>
              ))}
              <button
                className="nav-mobile-item nav-mobile-signout"
                onClick={() => go(onLogout)}
              >
                Sign Out
              </button>
            </>
          ) : (
            <>
              <button
                className="nav-mobile-item"
                onClick={() => go(() => onShowAuth('login'))}
              >
                Sign In
              </button>
              <button
                className="nav-mobile-item nav-mobile-primary"
                onClick={() => go(() => onShowAuth('signup'))}
              >
                Sign Up Free
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
